<div class="container">
  <div class="container__title">
    <h1 class="title">主人公になれる電車絵本</h1>
  </div>
  <div class="container__content">
    <p class="content">
      運転士になったり、電車を作ったり。
      <br
        *ngIf="mediaService.isLtLg$ | async"
      />東京メトロのオリジナル電車絵本。<br />電車が好きな子へ贈りたい、<br
        *ngIf="mediaService.isLtLg$ | async"
      />世界に一冊のオーダーメイド。
    </p>
  </div>
  <div class="container__button">
    <button
      class="button"
      (click)="onInfoClick()"
    >
      <span class="button__text">購入する</span>
    </button>
  </div>
</div>
